import { SET_PAIRS, SET_IS_FETCHING_MARKETS, SET_FAVORITES } from './action'
import { NETWORK_ENV } from '../../utils/httpRequest'
import { SUFIXBCOINS } from '../../utils/tradepair'
import { getAddress, getFavorites, getInitialFavorites } from '../../utils/favorites'

const initialState = {
  pairs: [],
  quoteAssets: [],
  isFetchingMarkets: true,
  favorites: getInitialFavorites(),
}

const STABLECOINS = ['TUSDB', 'THKDB', 'TGBPB', 'TCADB', 'TAUDB', 'USD', 'PAX', 'IDRTB', 'BKRW-AB7']

const getAssets = (data, type) => {
  const results = []
  data.forEach(item => {
    const pair = results.find(symbol => symbol.toUpperCase() === item[type].toUpperCase())
    if (!pair) {
      results.push(item[type])
    }
  })

  return results
}

const isAlts = quoteAsset =>
  !quoteAsset.includes('BTC') &&
  !quoteAsset.includes('BNB') &&
  !STABLECOINS.find(s => quoteAsset.includes(s))

const getTradePairTabs = data => {
  const tabs = [{ value: 'favorites', index: 0, displayName: 'favorites' }]
  const result = data.map(pair => {
    const upperCaseQuote = pair.quote_asset_symbol.toUpperCase()

    if (upperCaseQuote.includes('BTCB')) {
      pair.tab = 'BTCB'
      if (!tabs.find(item => item.value === 'BTCB')) {
        tabs.push({ value: 'BTCB', index: 2, displayName: 'BTC' })
      }
    }

    if (NETWORK_ENV === 'testnet' && upperCaseQuote.includes('BTC')) {
      pair.tab = 'BTC'
      if (!tabs.find(item => item.value === 'BTC')) {
        tabs.push({ value: 'BTC', index: 2, displayName: 'BTC' })
      }
    }

    if (upperCaseQuote.includes('BNB')) {
      pair.tab = 'BNB'
      if (!tabs.find(item => item.value === 'BNB')) {
        tabs.push({ value: 'BNB', index: 1, displayName: 'BNB' })
      }
    }

    if (isAlts(upperCaseQuote)) {
      pair.tab = 'ALTS'
      if (!tabs.find(item => item.value === 'ALTS')) {
        tabs.push({ value: 'ALTS', index: 3, displayName: 'ALTS' })
      }
    }

    if (
      STABLECOINS.find(s => upperCaseQuote.includes(s)) ||
      upperCaseQuote.includes('USD') ||
      upperCaseQuote.includes('PAX') ||
      upperCaseQuote.includes('TUSD')
    ) {
      pair.tab = 'FIATⓈ'
      if (!tabs.find(item => item.value === 'FIATⓈ')) {
        tabs.push({ value: 'FIATⓈ', index: 4, displayName: 'FIATⓈ' })
      }
    }

    pair.price = pair.price || pair.list_price
    pair.base_asset_displayname = pair.base_asset_symbol.replace(/-.+/i, '')
    pair.quote_asset_displayname = pair.quote_asset_symbol.replace(/-.+/i, '')

    if (SUFIXBCOINS.find(c => pair.base_asset_symbol.toUpperCase().includes(c))) {
      pair.base_asset_displayname = pair.base_asset_symbol.replace(/B-.+/i, '')
    }

    if (SUFIXBCOINS.find(c => pair.quote_asset_symbol.toUpperCase().includes(c))) {
      pair.quote_asset_displayname = pair.quote_asset_symbol.replace(/B-.+/i, '')
    }

    return pair
  })

  const pairs = result.sort((a, b) => {
    if (a.tab === 'BNB' && b.tab === 'BNB') {
      return b.volume - a.volume
    }
    if (a.tab === 'BNB' && b.tab !== 'BNB') {
      return -1
    }
    if (a.tab !== 'BNB' && b.tab === 'BNB') {
      return 1
    }
    return 1
  })

  return {
    pairs,
    tabs: tabs.sort((a, b) => a.index - b.index).map(item => item.displayName),
  }
}

const handleFavorites = data => {
  const address = getAddress()
  const favorites = getFavorites()
  if (address) {
    const userFavorites = favorites.favorites_logined?.find(f => !!f[address])
    if (!userFavorites) {
      const newFavorites = {}
      newFavorites[address] = data || []
      favorites.favorites_logined.push(newFavorites)
    } else if (data?.length > 0) {
      userFavorites[address] = data
    }
  } else if (data?.length > 0) {
    favorites.favorites_unLogined = data
  }

  window.localStorage.setItem('favorites', JSON.stringify(favorites))
  return data
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAIRS:
      // eslint-disable-next-line no-case-declarations
      const { tabs, pairs } = getTradePairTabs(action.data)
      return {
        ...state,
        pairs,
        tabs,
        quoteAssets: getAssets(action.data, 'quote_asset_symbol'),
      }

    case SET_IS_FETCHING_MARKETS:
      return {
        ...state,
        isFetchingMarkets: action.data,
      }

    case SET_FAVORITES:
      return {
        ...state,
        favorites: handleFavorites(action.data),
      }

    default:
      return state
  }
}
